// Copyright (c) 2022 Siemens

/**
 * @module js/landingModulePrereq
 */
import _appCtxSvc from 'js/appCtxService';
import cfgSvc from 'js/configurationService';
import _ from 'lodash';
import axios from 'axios';

const exports = {};

function changePrereqStatus(howMuch =0){
    let reqS = _appCtxSvc.getCtx('prereqState') || 0;
    reqS +=howMuch;
    _appCtxSvc.updateCtx('prereqState',reqS)
}

///landingSublocationPrereq Prerequisite
function filterAllowedCards(cards,cardsConfigCtx) {
    const  user = _appCtxSvc.getCtx('cognitoToken');
    const userRoles = user.accessToken.payload['cognito:groups'];
    let counter = 0;
    let FeaturesListNames = _appCtxSvc.getCtx('FeaturesListNames');

    var out = cards.list.map(function (card) {
        let migrationHide = card.hasOwnProperty('hideTile');
        card.isVisible = !migrationHide && _.intersection(userRoles, card.roles).length > 0;
        if (card.isVisible){
            if (card.hasOwnProperty('features')){
                if (card.features.some(fName =>{
                    return FeaturesListNames.indexOf(fName) !== -1;
                })){
                    counter++;                    
                }
                else{
                    card.isVisible = false;
                }
            }
            else{

                counter++;
            }             
        }
        return card;
    });
    _appCtxSvc.updateCtx('landingCards',counter);
    _appCtxSvc.updateCtx(cardsConfigCtx,{
        'list': out
    });
}

exports.solveWoCAuthentication = function() {
    console.debug('solveWoCAuthentication')
    const wocResult = _appCtxSvc.getCtx('wocResult')
    if (wocResult === undefined || wocResult === null){
        var prjC = _appCtxSvc.getCtx('oPINAuthenticationConfig');
        var locale = _appCtxSvc.getCtx('locale');
        var url = prjC.apiMI + 'TenantService/api/woc/token' + ((locale !== undefined) ? ('?language=' + locale) : '?language=en'); 
        return axios.get(url).then(function (result) {
            if (result && result.data) {
                _appCtxSvc.updateCtx('wocResult',result.data.Result);
            }
        }).catch (function ( error) {
            console.log('Silenced solveWoCAuthentication failure', error)
        });
    }
    return Promise.resolve();
};
exports.landingSublocationPrereq = function() {
    console.debug('###Prereq Enter landingSublocationPrereq')
    changePrereqStatus(1);
    _appCtxSvc.updateCtx( 'location.titles', {
        browserTitle:'Opcenter Intelligence',
        browserSubTitle:'Home'
    } );

    const cardsConfigRaw = _appCtxSvc.getCtx('cardsConfigRaw');
    let p1 = Promise.resolve();
    if ( cardsConfigRaw === null || cardsConfigRaw === undefined ) {
        p1 = cfgSvc.getCfg( 'cards-config' ).then(conf =>{
            _appCtxSvc.updateCtx('cardsConfigRaw',conf);
            filterAllowedCards(conf,'cardsConfig');
        });
    }
    return p1.then( async x => {
        const landingCards = _appCtxSvc.getCtx('landingCards');
        if ( landingCards !== null && landingCards === 1 ) {
            const cardsConfig = _appCtxSvc.getCtx( 'cardsConfig' );
            var card = cardsConfig.list.find( function( c ) {
                return c.isVisible;
            } );
            var url = 'https://' +  window.location.hostname + '/' +  card.mindsphereEndpoint + card.mindsphereUrl;
            window.location.replace( url );
        }
        await exports.solveWoCAuthentication();
        changePrereqStatus(-1);
        console.debug('###Prereq Exit landingSublocationPrereq');
    } );
};

export default exports;
